<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <table class="table table-striped table-sm table-hover">
                    <thead class="bg-primary text-white">
                    <tr>
                        <th scope="col">
                            Folyamat
                        </th>
                        <th scope="col">
                            Értesítendő e-mail címek
                        </th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="notification in emailNotifications">
                        <th scope="row">{{notification.name}}</th>
                        <td>{{notification.emails ? notification.emails : '-'}}</td>
                        <td>
                            <button type="submit" class="btn btn-sm btn-primary" @click="editEmailNotification(notification)">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card mb-2">
            <div class="card-header">
                <div class="collapsed card-link" data-parent="#accordion">
                    E-mail értesítés folyamathoz rendelése
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group">
                            <label for="name" class="sr-only">Folyamat</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="name"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="inputValue.name"
                                    placeholder="Folyamat"
                                    :disabled="true"
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-xl-12">
                        <div class="form-group">
                            <label for="emails" class="sr-only">Értesítendő e-mail címek</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <textarea
                                    id="emails"
                                    class="form-control form-control-sm"
                                    v-model="inputValue.emails"
                                    placeholder="Értesítendő e-mail címek*"
                                    :disabled="isLoading"
                                    required
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-xl-2">
                        <button type="submit" class="btn btn-primary btn-block" @click.prevent="saveEmailNotification"
                                :disabled="isLoading">
                            <i class="fa fa-save"></i>
                            Mentés
                        </button>
                    </div>
                    <div class="col-lg-3 col-xl-2">
                        <button type="submit" class="btn btn-primary btn-block" @click.prevent="cancelEdit"
                                :disabled="isLoading">
                            Mégsem
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'EmailNotificationController',
        data(){
            return {
                emailNotifications: [],
                inputValue: {},
                isLoading: false
            }
        },
        methods: {
            resetInputValue(){
                this.inputValue = {
                    handler: null,
                    name: '',
                    emails: ''
                }
            },
            loadData(){
                this.$store.dispatch('EmailNotificationModul/getEmailNotificationList', {
                    filter: this.filter,
                    order: this.order,
                    result: (res)=> {
                        this.emailNotifications = res.data.emailMethodList;
                    }
                });
            },
            saveEmailNotification(){
                this.$store.dispatch("EmailNotificationModul/saveEmailNotification",{
                    data: this.inputValue,
                    result: (res) => {
                        this.resetInputValue();
                        this.loadData();
                    },
                    reject: (rej) => {

                    }
                })
            },
            editEmailNotification(dict){
                this.inputValue = Object.assign({}, dict);
                console.log(this.inputValue);
            },
            cancelEdit(){
                this.resetInputValue();
            }
        },
        mounted(){
            this.loadData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/EmailNotificationController.vue